import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../redux/snackbar/actions";

const PricingDetails = ({
  subtotal,
  cgst,
  sgst,
  discount,
  total,
  voucher,
  setTotalAmt,
  setVoucher,
}) => {
  const dispatch = useDispatch();
  const [calculatedTotal, setCalculatedTotal] = useState(total);
  const [discountAmount, setDiscountAmount] = useState(0);

  useEffect(() => {
    const parsedSubtotal = parseFloat(subtotal) || 0;
    const parsedCgst = parseFloat(cgst) || 0;
    const parsedSgst = parseFloat(sgst) || 0;
    const voucherDiscount = voucher?.offer_discount
      ? parseFloat(voucher.offer_discount)
      : 0;

    let newTotal = parsedSubtotal;
    let discountValue = 0;

    if (voucher) {
      if (voucher.offer_discount_type === "percentage") {
        discountValue = (parsedSubtotal * voucherDiscount) / 100;
        newTotal = parsedSubtotal - discountValue;

        if (newTotal < 0) {
          dispatch(
            showSnackbar({
              message:
                "The total value cannot be negative. Please remove or adjust the voucher.",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "warning",
            })
          );
          setVoucher(null);
          newTotal = parsedSubtotal;
          discountValue = 0;
        }
      } else {
        discountValue = voucherDiscount;
        newTotal = parsedSubtotal - discountValue;

        if (newTotal < 0) {
          dispatch(
            showSnackbar({
              message:
                "The total value cannot be negative. Please remove or adjust the voucher.",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "warning",
            })
          );
          setVoucher(null);
          newTotal = parsedSubtotal;
          discountValue = 0;
        }
      }
      newTotal += parsedCgst + parsedSgst;
    } else {
      newTotal = parsedSubtotal + parsedCgst + parsedSgst;
    }
    setDiscountAmount(discountValue);
    setCalculatedTotal(newTotal);
    setTotalAmt(newTotal);
  }, [voucher, subtotal, cgst, sgst, setVoucher, setTotalAmt]);

  return (
    <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Price Details
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography>Sub Total</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right">
            ₹ {Number(subtotal)?.toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography>Discount</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right">
            {voucher
              ? voucher.offer_discount_type === "percentage"
                ? `₹${discountAmount.toFixed(2)}`
                : `₹${(Number(voucher?.offer_discount) || 0).toFixed(2)}`
              : `₹0.00`}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="h6">
            Grand Total
            <span style={{ fontSize: "14px" }}>
              &nbsp;(Inclusive of all taxes)
            </span>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" align="right">
            ₹ {Number(calculatedTotal)?.toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PricingDetails;
